
import React, { useEffect, useState } from 'react';
import { Fragment } from 'react';
import PageSEO from '../Common/PageSEO';
import { useLocale } from '../../localization/LocaleContext';
import Loader from '../../loader/Loader';
import Footer from '../Footer/Footer';
import OnlinePayments from './OnlinePayments';

function OnlinePaymentsMain() {
    const { t, locale } = useLocale();
   const[loader, SetLoader] = useState(false)
    useEffect(() =>
    setTimeout(() =>{
        SetLoader(true)
    },1500)[loader]  
    )
    if (!loader) {
        return <Loader/>;
    }
    return(
        <Fragment>
            <PageSEO title={t('meta.onlinePaymentsTitle')} description={t('meta.onlinePaymentsDescription')} path="/online-payments" locale={locale} />
            <OnlinePayments/>
            <Footer/>
        </Fragment>
    )
    
}

export default OnlinePaymentsMain;